import React from 'react';
import { pillars } from '../data/content';
import { SectionLabel } from './ui/SectionLabel';
import { Reveal } from './ui/Reveal';
export function Pillars() {
  return <section className="grain bg-ink px-4 py-14 sm:px-5 sm:py-24" data-id="element-155" data-mp="2e9b6qjz20yfd">
      <div className="mx-auto max-w-6xl" data-id="element-156" data-mp="2j97e8t6yn7zo">
        <Reveal data-id="element-157" data-mp="2o1h1g1goxty9">
          <SectionLabel tone="dark" data-id="element-158" data-mp="2o20jdi6ccica">Il sistema centrale</SectionLabel>
          <h2 className="display mx-auto mt-5 max-w-[22ch] text-center text-[1.7rem] text-cream sm:text-[3.1rem]" data-id="element-159" data-mp="2o3bhp2h0oxw0">
            I 6 pilastri del loro{' '}
            <span className="text-sun" data-id="element-160" data-mp="2xybu43qa904m">laboratorio di robotica a casa.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] font-semibold leading-relaxed text-cream/60 sm:mt-5 sm:text-lg" data-id="element-161" data-mp="322ba8l7nhwxg">
            Una progressione pratica dalle fondamenta dell’inventore fino alle
            creazioni originali.
          </p>
        </Reveal>

        <ol className="mt-9 grid gap-4 sm:mt-12 sm:gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-162" data-mp="1clsbr2c1ygtr">
          {pillars.map((pillar, index) => <Reveal key={pillar.number} delay={index * 0.04} data-id="element-163" data-mp="117dph9sting2" data-mpi={index}>
              <li className="h-full rounded-[1.5rem] border border-cream/15 bg-cream/[0.05] p-6 transition-colors duration-150 ease-snap hover:border-sun/40 hover:bg-cream/[0.08] sm:rounded-[1.75rem] sm:p-8" data-id="element-164" data-mp="wfvs0vq074zu">
                <div className="flex items-center gap-3" data-id="element-165" data-mp="nfh2tl9x55r2">
                  <p className="display text-2xl text-sun sm:text-3xl" data-id="element-166" data-mp="ncumox8yphx8">
                    {pillar.number}
                  </p>
                  <span className="rule-dots h-[6px] flex-1 rounded-full opacity-40" aria-hidden="true" data-id="element-167" data-mp="1g3w65ajotzmk" />
                </div>
                <h3 className="mt-4 text-base font-black leading-snug text-cream sm:mt-5 sm:text-lg" data-id="element-168" data-mp="1b3gtymb56y66">
                  {pillar.title}
                </h3>
                <p className="mt-2 text-[15px] font-semibold leading-relaxed text-cream/60 sm:mt-2.5 sm:text-base" data-id="element-169" data-mp="3vur26lmfbwv5">
                  {pillar.description}
                </p>
              </li>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}